export default __webpack_public_path__ + "static/media/redHat.0432205f.png";